import React, { useState } from "react";
import { TopPositionsTable } from "./components/table/TopPositionsTable";
import { TopPositionsHeader } from "./components/header/TopPositionsHeader";
import { useQuery } from "react-query";
import { fetchPopularPositionsRepo } from "./data/repository/FetchTopProductsRepository";
import { useSelector } from "react-redux";
import {
  selectCurrentLocation,
  selectCurrentRestaurantGroupId,
} from "@src/store/app_manager/selector";
import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import { subDays } from "date-fns";
import { NoGraphComponent } from "../OrderGraph/components/NoGraphComponent";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DownloadExcel } from "../../components/DownloadExcel";

dayjs.extend(utc);

export const TopPositions: React.FC = () => {
  const weekBeforeDate = subDays(new Date(), 13);

  const onPeriodSelected = (start: Date, end: Date) => {
    setStartPeriod(dayjs(start).utc().toISOString());
    setEndPeriod(dayjs(end).utc().toISOString());
  };

  const selectedLocation = useSelector(selectCurrentLocation);
  const currentGroup = useSelector(selectCurrentRestaurantGroupId);

  const [selectedAggregator, setSelectedAggregator] = useState("wolt");

  const onAggregatorSelect = (aggregator: string) => {
    setSelectedAggregator(aggregator);
  };

  const [startPeriod, setStartPeriod] = React.useState<string>(
    dayjs(weekBeforeDate).utc().toISOString()
  );
  const [endPeriod, setEndPeriod] = React.useState<string>(
    dayjs(subDays(new Date(), 6)).utc().toISOString()
  );

  const [sortByField, setSortByField] = useState("orders");

  const { data, status } = useQuery({
    queryKey: [
      "analytics-top",
      selectedAggregator,
      selectedLocation,
      startPeriod,
      endPeriod,
      sortByField,
    ],
    queryFn: (_) =>
      fetchPopularPositionsRepo.execute({
        startDate: startPeriod,
        endDate: endPeriod,
        restaurantId: selectedLocation === "all" ? "" : selectedLocation,
        groupId: currentGroup,
        aggregator: selectedAggregator,
        sortBy: sortByField,
      }),
    refetchOnWindowFocus: false,
  });

  return (
    <>
      <TopPositionsHeader
        onPeriodSelected={onPeriodSelected}
        onAggregatorSelect={onAggregatorSelect}
      />
      {status === "loading" && (
        <Box alignItems={"center"} display={"flex"} flexDirection={"column"}>
          <CircularProgress />
        </Box>
      )}
      {status === "error" && <Box />}
      {status === "success" &&
        (data && data.products.length > 0 ? (
          <TopPositionsTable
            tableBodyData={data}
            onSort={setSortByField}
            downloadLink={data.file}
          />
        ) : (
          <>
            <NoGraphComponent />
          </>
        ))}
    </>
  );
};